// @flow

// Libs
import _isEmpty from 'lodash/isEmpty'
import _map from 'lodash/map'
import React, { Component } from 'react'
import L from 'leaflet'
import 'leaflet-path-drag'

// Components
import { LayerGroup, Marker } from 'react-leaflet'
import ExistingGrid from './ExistingGrid'

// Types
import type { Point } from 'fc-model-sampling-points/types'

// Image
import gridCenterIcon from '../icons/grid-center.url.svg'
import gridCenterSelectedIcon from '../icons/grid-center-selected.url.svg'
import previousPointSvg from '../icons/previous-point.url.svg'

// Local
const gridCenter = L.icon({
  iconUrl: gridCenterIcon,
  iconSize: [15, 15],
})
const gridCenterSelected = L.icon({
  iconUrl: gridCenterSelectedIcon,
  iconSize: [15, 15],
})
const previousPointIcon = L.icon({
  iconUrl: previousPointSvg,
  iconSize: [7, 7],
})

const filterText = (text: ?string): React.element<any> => {
  return L.divIcon({
    html: `<span style='display: block; transform: translate(0, -15px)'> ${text}</span>`,
    className: 'mapDivIcon',
  })
}

type Props = {
  gridData: Object,
  operations: Array<Object>,
  field: Asset,
  samplingPoints: Array<Point>,
  previousPoints: Array<Point>,
  selectedSamplingPoint: ?number,
  filter: ?string,
  isPreviousPointsShown: boolean,
}

class HeftyExistingGrid extends Component {
  props: Props
  render (): React.Element<any> {
    const {
      gridData,
      operations,
      field,
      samplingPoints,
      previousPoints,
      selectedSamplingPoint,
      filter,
    } = this.props
    const shouldRenderPrevPoints = !_isEmpty(previousPoints) && this.props.isPreviousPointsShown

    return (
      <div data-test='hefty-grids'>
        <LayerGroup draggable >
          {_isEmpty(samplingPoints)
            ? gridData && _isEmpty(operations) && field
              ? <ExistingGrid gridData={gridData} />
              : null
            : _map(samplingPoints, (samplingPoint: Object, i: number): React.element<any> => {
              if (samplingPoint.latitude && samplingPoint.longitude) {
                const position = [ samplingPoint.latitude, samplingPoint.longitude ]
                const soilTests = samplingPoint.soilTestResults
                return (
                  <div key={`sampling-point-${i}`}>
                    <Marker
                      position={position}
                      icon={selectedSamplingPoint === samplingPoint.id
                        ? gridCenterSelected : gridCenter}
                    />
                    {filter
                      ? soilTests[0]
                        ? <Marker
                          position={position}
                          icon={soilTests[0][filter]
                            ? filterText(soilTests[0][filter]) : filterText('')}
                        />
                        : null
                      : null
                    }
                  </div>)
              }
            })}
          {shouldRenderPrevPoints && (_map(previousPoints, (point: Point, i: number): React.element<any> => (
            point.latitude && point.longitude ? (<div key={`previous-point-${i}`}>
              <Marker
                position={[ point.latitude, point.longitude ]}
                icon={previousPointIcon}
              />
            </div>) : null
          )))}
        </LayerGroup>
      </div>
    )
  }
}

export default HeftyExistingGrid
